(() => {
  if (window.__kitBasicos) return;
  window.__kitBasicos = true;

  /* Mismo mecanismo que Kit Esenciales: el carrito recibe UNA linea del
     producto kit con los componentes en la propiedad _componentes y la
     funcion Cart Transform la desarma. Nunca se agregan componentes sueltos.
     Los botones con data-kb-pick abren una ventana para elegir aroma antes
     de agregar; el selector de la lista y la ventana siempre estan sincronizados. */

  const config = () => document.querySelector('[data-kb-config]');
  const slots = () => Array.from(document.querySelectorAll('[data-kb-slot]'));
  const aromaSelect = () => document.querySelector('[data-kb-aroma]');
  const aromaSelects = () => Array.from(document.querySelectorAll('[data-kb-aroma]'));
  const modal = () => document.querySelector('[data-kb-modal]');
  let lastFocus = null;

  function syncChips(select) {
    document.querySelectorAll('[data-kb-chip="' + select.id + '"]').forEach((c) => {
      c.checked = c.value === select.value;
    });
  }

  function onAroma(e) {
    const select = e.target.closest('[data-kb-aroma]');
    if (!select) return;
    const slot = select.closest('[data-kb-slot]');
    if (slot) slot.dataset.variantId = select.value;
    syncChips(select);
  }

  /* Botones de aroma (opcional): reflejan y controlan el select oculto */
  function onChip(e) {
    const chip = e.target.closest('input[data-kb-chip]');
    if (!chip || chip.disabled) return;
    const select = document.getElementById(chip.dataset.kbChip);
    if (!select) return;
    select.value = chip.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function items() {
    const cfg = config();
    const list = slots();
    const kitVariant = cfg && cfg.dataset.kitVariant;
    if (!kitVariant) return null; /* nunca agregar componentes sueltos: siempre como producto kit */
    const props = { _componentes: list.map((s) => s.dataset.variantId).join(',') };
    list.forEach((s) => {
      const sel = s.querySelector('[data-kb-aroma]');
      if (!sel) return;
      const opt = sel.options[sel.selectedIndex];
      props[s.dataset.label || 'Aroma'] = (opt && opt.dataset.aroma) || '';
    });
    return [{ id: Number(kitVariant), quantity: 1, properties: props }];
  }

  function setBusy(on) {
    document.querySelectorAll('[data-kb-add], [data-kb-confirm]').forEach((b) => {
      if (!b.dataset.label) b.dataset.label = b.textContent;
      b.disabled = on;
      b.textContent = on ? 'Agregando…' : b.dataset.label;
    });
  }

  function setError(msg) {
    document.querySelectorAll('[data-kb-error]').forEach((el) => {
      el.textContent = msg || '';
      el.hidden = !msg;
    });
  }

  async function openCart() {
    const cfg = config();
    const cartUrl = (cfg && cfg.dataset.cartUrl) || '/cart';
    const sc = window.Rebuy && window.Rebuy.SmartCart;
    if (!sc || typeof sc.show !== 'function') {
      window.location.href = cartUrl;
      return;
    }
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      if (typeof sc.setCartAsync === 'function') await sc.setCartAsync(cart);
      else if (typeof sc.setCart === 'function') sc.setCart(cart);
      if (typeof sc.updateCartCount === 'function') sc.updateCartCount();
      sc.show();
      setBusy(false);
    } catch (_) {
      window.location.href = cartUrl;
    }
  }

  async function addToCart() {
    setError('');
    const list = slots();
    if (!list.length || list.some((s) => !s.dataset.variantId)) {
      setError('No pudimos armar el kit. Recarga la página e intenta de nuevo.');
      return;
    }
    const payload = items();
    if (!payload) {
      setError('El kit no está disponible en este momento. Intenta más tarde.');
      return;
    }
    setBusy(true);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: payload }),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.description || 'No pudimos agregar el kit.');
      }
      await openCart();
    } catch (err) {
      setError(err.message || 'No pudimos agregar el kit. Intenta de nuevo.');
      setBusy(false);
    }
  }

  /* ---------- Ventana para elegir aroma ---------- */
  function buildOptions(sel, box, group) {
    if (!group) box.textContent = '';
    const opts = Array.from(sel.options).sort((a, b) => Number(b.defaultSelected) - Number(a.defaultSelected));
    opts.forEach((opt) => {
      const label = document.createElement('label');
      label.className = 'kb-opt';
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = group ? 'kb-aroma-pick-' + sel.id : 'kb-aroma-pick';
      if (group) input.dataset.target = sel.id;
      input.value = opt.value;
      input.checked = opt.selected;
      input.disabled = opt.disabled;
      const txt = document.createElement('span');
      txt.className = 'kb-opt__txt';
      const name = document.createElement('strong');
      name.textContent = opt.dataset.aroma || opt.textContent;
      txt.appendChild(name);
      const note = opt.dataset.note || (opt.disabled ? 'agotado' : '');
      if (note) {
        const small = document.createElement('span');
        small.textContent = opt.disabled && opt.dataset.note ? opt.dataset.note + ' · agotado' : note;
        txt.appendChild(small);
      }
      label.appendChild(input);
      label.appendChild(txt);
      box.appendChild(label);
    });
  }

  function buildGroups(sels, box) {
    box.textContent = '';
    box.classList.add('kb-modal__opts--groups');
    sels.forEach((sel) => {
      const slot = sel.closest('[data-kb-slot]');
      const wrap = document.createElement('div');
      wrap.className = 'kb-modal__group';
      const title = document.createElement('p');
      title.className = 'kb-modal__group-title';
      title.textContent = (slot && slot.dataset.label) || '';
      const grid = document.createElement('div');
      grid.className = 'kb-modal__grid';
      buildOptions(sel, grid, true);
      wrap.appendChild(title);
      wrap.appendChild(grid);
      box.appendChild(wrap);
    });
  }

  function openPicker() {
    const sels = aromaSelects();
    const sel = sels[0];
    const m = modal();
    if (!sel || !m) {
      addToCart();
      return;
    }
    const box = m.querySelector('[data-kb-opts]');
    if (sels.length > 1) buildGroups(sels, box);
    else buildOptions(sel, box);
    lastFocus = document.activeElement;
    m.hidden = false;
    document.documentElement.classList.add('kb-lock');
    const checked = box.querySelector('input:checked') || box.querySelector('input:not([disabled])');
    if (checked) checked.focus();
  }

  function closePicker() {
    const m = modal();
    if (!m || m.hidden) return;
    m.hidden = true;
    document.documentElement.classList.remove('kb-lock');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function onPick(e) {
    const input = e.target.closest('input[name^="kb-aroma-pick"]');
    if (!input) return;
    const sel = input.dataset.target ? document.getElementById(input.dataset.target) : aromaSelect();
    if (!sel) return;
    sel.value = input.value;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function watchBar() {
    const bar = document.querySelector('[data-kb-bar]');
    if (!bar) return;
    /* Aparece desde el primer scroll (umbral en px, data-kb-bar-offset) */
    const offset = Number(bar.dataset.kbBarOffset || 80);
    let ticking = false;
    const update = () => {
      bar.classList.toggle('is-visible', window.scrollY > offset);
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }

  document.addEventListener('change', (e) => {
    onChip(e);
    onAroma(e);
    onPick(e);
  });
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-kb-close]')) {
      e.preventDefault();
      closePicker();
      return;
    }
    if (e.target.closest('[data-kb-confirm]')) {
      e.preventDefault();
      closePicker();
      addToCart();
      return;
    }
    const btn = e.target.closest('[data-kb-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.hasAttribute('data-kb-pick')) openPicker();
    else addToCart();
  });
  /* ---------- Carrusel de reseñas ---------- */
  function updateCarousel(track) {
    const wrap = track.closest('[data-kb-carousel]');
    if (!wrap) return;
    const max = track.scrollWidth - track.clientWidth - 2;
    const prev = wrap.querySelector('[data-kb-scroll="-1"]');
    const next = wrap.querySelector('[data-kb-scroll="1"]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  function initCarousels() {
    document.querySelectorAll('[data-kb-track]').forEach((track) => {
      track.addEventListener('scroll', () => updateCarousel(track), { passive: true });
      updateCarousel(track);
    });
    window.addEventListener('resize', () => document.querySelectorAll('[data-kb-track]').forEach(updateCarousel));
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-kb-scroll]');
    if (!btn) return;
    const wrap = btn.closest('[data-kb-carousel]');
    const track = wrap && wrap.querySelector('[data-kb-track]');
    if (!track) return;
    const card = track.firstElementChild;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    track.scrollBy({ left: Number(btn.dataset.kbScroll) * step, behavior: 'smooth' });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closePicker();
  });

  function init() {
    watchBar();
    initCarousels();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
